module.exports = __webpack_public_path__ + "media/application/images/2018/2018-list-tick-2176df9d85bb92fce89a4943087d172c.svg";